import { StudySubjectBulkCreateItem } from '@common/config/api/client'
import Papa from 'papaparse'
import * as XLSX from 'xlsx'

export const parseSubjectsCSV = async (csvText: string): Promise<StudySubjectBulkCreateItem[]> => {
  return new Promise((resolve) => {
    Papa.parse<StudySubjectBulkCreateItem>(csvText, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = results.data
        resolve(
          parsedData.map((row) => ({
            pseudo_id: row.pseudo_id,
            primary_site_pseudo_id: row.primary_site_pseudo_id,
            secondary_site_pseudo_id: row.secondary_site_pseudo_id,
            status: row.status,
            eligibility_status: row.eligibility_status,
          })),
        )
      },
    })
  })
}

export const parseSubjectsExcel = async (file: File): Promise<StudySubjectBulkCreateItem[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        if (!e.target?.result) {
          reject(new Error('Failed to read file'))
          return
        }

        const data = new Uint8Array(e.target.result as ArrayBuffer)
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = XLSX.utils.sheet_to_json<StudySubjectBulkCreateItem>(worksheet)

        resolve(
          jsonData.map((row) => ({
            pseudo_id: row.pseudo_id,
            primary_site_pseudo_id: row.primary_site_pseudo_id,
            secondary_site_pseudo_id: row.secondary_site_pseudo_id,
            status: row.status,
            eligibility_status: row.eligibility_status,
          })),
        )
      } catch (error) {
        reject(error)
      }
    }
    reader.onerror = (error) => reject(error)
    reader.readAsArrayBuffer(file)
  })
}
